var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto col-12"},[_c('h1',{staticClass:"mt-5 display-4 text-uppercase text-muted"},[_vm._v("404")]),_c('p',{staticClass:"text-muted"},[_vm._v("Looks like this page doesn't exist")]),_c('p',[_c('a',{staticClass:"dark-green",attrs:{"href":"/"}},[_vm._v("back to the dashboard")])])])
}]

export { render, staticRenderFns }